// OISST slider dates (auto-updated by oisst-consolidated.ipynb)

export const oisstPalauDates = [
  '1981-09-01',
  '1981-10-01',
  '1981-11-01',
  '1981-12-01',
  '1982-01-01',
  '1982-02-01',
  '1982-03-01',
  '1982-04-01',
  '1982-05-01',
  '1982-06-01',
  '1982-07-01',
  '1982-08-01',
  '1982-09-01',
  '1982-10-01',
  '1982-11-01',
  '1982-12-01',
  '1983-01-01',
  '1983-02-01',
  '1983-03-01',
  '1983-04-01',
  '1983-05-01',
  '1983-06-01',
  '1983-07-01',
  '1983-08-01',
  '1983-09-01',
  '1983-10-01',
  '1983-11-01',
  '1983-12-01',
  '1984-01-01',
  '1984-02-01',
  '1984-03-01',
  '1984-04-01',
  '1984-05-01',
  '1984-06-01',
  '1984-07-01',
  '1984-08-01',
  '1984-09-01',
  '1984-10-01',
  '1984-11-01',
  '1984-12-01',
  '1985-01-01',
  '1985-02-01',
  '1985-03-01',
  '1985-04-01',
  '1985-05-01',
  '1985-06-01',
  '1985-07-01',
  '1985-08-01',
  '1985-09-01',
  '1985-10-01',
  '1985-11-01',
  '1985-12-01',
  '1986-01-01',
  '1986-02-01',
  '1986-03-01',
  '1986-04-01',
  '1986-05-01',
  '1986-06-01',
  '1986-07-01',
  '1986-08-01',
  '1986-09-01',
  '1986-10-01',
  '1986-11-01',
  '1986-12-01',
  '1987-01-01',
  '1987-02-01',
  '1987-03-01',
  '1987-04-01',
  '1987-05-01',
  '1987-06-01',
  '1987-07-01',
  '1987-08-01',
  '1987-09-01',
  '1987-10-01',
  '1987-11-01',
  '1987-12-01',
  '1988-01-01',
  '1988-02-01',
  '1988-03-01',
  '1988-04-01',
  '1988-05-01',
  '1988-06-01',
  '1988-07-01',
  '1988-08-01',
  '1988-09-01',
  '1988-10-01',
  '1988-11-01',
  '1988-12-01',
  '1989-01-01',
  '1989-02-01',
  '1989-03-01',
  '1989-04-01',
  '1989-05-01',
  '1989-06-01',
  '1989-07-01',
  '1989-08-01',
  '1989-09-01',
  '1989-10-01',
  '1989-11-01',
  '1989-12-01',
  '1990-01-01',
  '1990-02-01',
  '1990-03-01',
  '1990-04-01',
  '1990-05-01',
  '1990-06-01',
  '1990-07-01',
  '1990-08-01',
  '1990-09-01',
  '1990-10-01',
  '1990-11-01',
  '1990-12-01',
  '1991-01-01',
  '1991-02-01',
  '1991-03-01',
  '1991-04-01',
  '1991-05-01',
  '1991-06-01',
  '1991-07-01',
  '1991-08-01',
  '1991-09-01',
  '1991-10-01',
  '1991-11-01',
  '1991-12-01',
  '1992-01-01',
  '1992-02-01',
  '1992-03-01',
  '1992-04-01',
  '1992-05-01',
  '1992-06-01',
  '1992-07-01',
  '1992-08-01',
  '1992-09-01',
  '1992-10-01',
  '1992-11-01',
  '1992-12-01',
  '1993-01-01',
  '1993-02-01',
  '1993-03-01',
  '1993-04-01',
  '1993-05-01',
  '1993-06-01',
  '1993-07-01',
  '1993-08-01',
  '1993-09-01',
  '1993-10-01',
  '1993-11-01',
  '1993-12-01',
  '1994-01-01',
  '1994-02-01',
  '1994-03-01',
  '1994-04-01',
  '1994-05-01',
  '1994-06-01',
  '1994-07-01',
  '1994-08-01',
  '1994-09-01',
  '1994-10-01',
  '1994-11-01',
  '1994-12-01',
  '1995-01-01',
  '1995-02-01',
  '1995-03-01',
  '1995-04-01',
  '1995-05-01',
  '1995-06-01',
  '1995-07-01',
  '1995-08-01',
  '1995-09-01',
  '1995-10-01',
  '1995-11-01',
  '1995-12-01',
  '1996-01-01',
  '1996-02-01',
  '1996-03-01',
  '1996-04-01',
  '1996-05-01',
  '1996-06-01',
  '1996-07-01',
  '1996-08-01',
  '1996-09-01',
  '1996-10-01',
  '1996-11-01',
  '1996-12-01',
  '1997-01-01',
  '1997-02-01',
  '1997-03-01',
  '1997-04-01',
  '1997-05-01',
  '1997-06-01',
  '1997-07-01',
  '1997-08-01',
  '1997-09-01',
  '1997-10-01',
  '1997-11-01',
  '1997-12-01',
  '1998-01-01',
  '1998-02-01',
  '1998-03-01',
  '1998-04-01',
  '1998-05-01',
  '1998-06-01',
  '1998-07-01',
  '1998-08-01',
  '1998-09-01',
  '1998-10-01',
  '1998-11-01',
  '1998-12-01',
  '1999-01-01',
  '1999-02-01',
  '1999-03-01',
  '1999-04-01',
  '1999-05-01',
  '1999-06-01',
  '1999-07-01',
  '1999-08-01',
  '1999-09-01',
  '1999-10-01',
  '1999-11-01',
  '1999-12-01',
  '2000-01-01',
  '2000-02-01',
  '2000-03-01',
  '2000-04-01',
  '2000-05-01',
  '2000-06-01',
  '2000-07-01',
  '2000-08-01',
  '2000-09-01',
  '2000-10-01',
  '2000-11-01',
  '2000-12-01',
  '2001-01-01',
  '2001-02-01',
  '2001-03-01',
  '2001-04-01',
  '2001-05-01',
  '2001-06-01',
  '2001-07-01',
  '2001-08-01',
  '2001-09-01',
  '2001-10-01',
  '2001-11-01',
  '2001-12-01',
  '2002-01-01',
  '2002-02-01',
  '2002-03-01',
  '2002-04-01',
  '2002-05-01',
  '2002-06-01',
  '2002-07-01',
  '2002-08-01',
  '2002-09-01',
  '2002-10-01',
  '2002-11-01',
  '2002-12-01',
  '2003-01-01',
  '2003-02-01',
  '2003-03-01',
  '2003-04-01',
  '2003-05-01',
  '2003-06-01',
  '2003-07-01',
  '2003-08-01',
  '2003-09-01',
  '2003-10-01',
  '2003-11-01',
  '2003-12-01',
  '2004-01-01',
  '2004-02-01',
  '2004-03-01',
  '2004-04-01',
  '2004-05-01',
  '2004-06-01',
  '2004-07-01',
  '2004-08-01',
  '2004-09-01',
  '2004-10-01',
  '2004-11-01',
  '2004-12-01',
  '2005-01-01',
  '2005-02-01',
  '2005-03-01',
  '2005-04-01',
  '2005-05-01',
  '2005-06-01',
  '2005-07-01',
  '2005-08-01',
  '2005-09-01',
  '2005-10-01',
  '2005-11-01',
  '2005-12-01',
  '2006-01-01',
  '2006-02-01',
  '2006-03-01',
  '2006-04-01',
  '2006-05-01',
  '2006-06-01',
  '2006-07-01',
  '2006-08-01',
  '2006-09-01',
  '2006-10-01',
  '2006-11-01',
  '2006-12-01',
  '2007-01-01',
  '2007-02-01',
  '2007-03-01',
  '2007-04-01',
  '2007-05-01',
  '2007-06-01',
  '2007-07-01',
  '2007-08-01',
  '2007-09-01',
  '2007-10-01',
  '2007-11-01',
  '2007-12-01',
  '2008-01-01',
  '2008-02-01',
  '2008-03-01',
  '2008-04-01',
  '2008-05-01',
  '2008-06-01',
  '2008-07-01',
  '2008-08-01',
  '2008-09-01',
  '2008-10-01',
  '2008-11-01',
  '2008-12-01',
  '2009-01-01',
  '2009-02-01',
  '2009-03-01',
  '2009-04-01',
  '2009-05-01',
  '2009-06-01',
  '2009-07-01',
  '2009-08-01',
  '2009-09-01',
  '2009-10-01',
  '2009-11-01',
  '2009-12-01',
  '2010-01-01',
  '2010-02-01',
  '2010-03-01',
  '2010-04-01',
  '2010-05-01',
  '2010-06-01',
  '2010-07-01',
  '2010-08-01',
  '2010-09-01',
  '2010-10-01',
  '2010-11-01',
  '2010-12-01',
  '2011-01-01',
  '2011-02-01',
  '2011-03-01',
  '2011-04-01',
  '2011-05-01',
  '2011-06-01',
  '2011-07-01',
  '2011-08-01',
  '2011-09-01',
  '2011-10-01',
  '2011-11-01',
  '2011-12-01',
  '2012-01-01',
  '2012-02-01',
  '2012-03-01',
  '2012-04-01',
  '2012-05-01',
  '2012-06-01',
  '2012-07-01',
  '2012-08-01',
  '2012-09-01',
  '2012-10-01',
  '2012-11-01',
  '2012-12-01',
  '2013-01-01',
  '2013-02-01',
  '2013-03-01',
  '2013-04-01',
  '2013-05-01',
  '2013-06-01',
  '2013-07-01',
  '2013-08-01',
  '2013-09-01',
  '2013-10-01',
  '2013-11-01',
  '2013-12-01',
  '2014-01-01',
  '2014-02-01',
  '2014-03-01',
  '2014-04-01',
  '2014-05-01',
  '2014-06-01',
  '2014-07-01',
  '2014-08-01',
  '2014-09-01',
  '2014-10-01',
  '2014-11-01',
  '2014-12-01',
  '2015-01-01',
  '2015-02-01',
  '2015-03-01',
  '2015-04-01',
  '2015-05-01',
  '2015-06-01',
  '2015-07-01',
  '2015-08-01',
  '2015-09-01',
  '2015-10-01',
  '2015-11-01',
  '2015-12-01',
  '2016-01-01',
  '2016-02-01',
  '2016-03-01',
  '2016-04-01',
  '2016-05-01',
  '2016-06-01',
  '2016-07-01',
  '2016-08-01',
  '2016-09-01',
  '2016-10-01',
  '2016-11-01',
  '2016-12-01',
  '2017-01-01',
  '2017-02-01',
  '2017-03-01',
  '2017-04-01',
  '2017-05-01',
  '2017-06-01',
  '2017-07-01',
  '2017-08-01',
  '2017-09-01',
  '2017-10-01',
  '2017-11-01',
  '2017-12-01',
  '2018-01-01',
  '2018-02-01',
  '2018-03-01',
  '2018-04-01',
  '2018-05-01',
  '2018-06-01',
  '2018-07-01',
  '2018-08-01',
  '2018-09-01',
  '2018-10-01',
  '2018-11-01',
  '2018-12-01',
  '2019-01-01',
  '2019-02-01',
  '2019-03-01',
  '2019-04-01',
  '2019-05-01',
  '2019-06-01',
  '2019-07-01',
  '2019-08-01',
  '2019-09-01',
  '2019-10-01',
  '2019-11-01',
  '2019-12-01',
  '2020-01-01',
  '2020-02-01',
  '2020-03-01',
  '2020-04-01',
  '2020-05-01',
  '2020-06-01',
  '2020-07-01',
  '2020-08-01',
  '2020-09-01',
  '2020-10-01',
  '2020-11-01',
  '2020-12-01',
  '2021-01-01',
  '2021-02-01',
  '2021-03-01',
  '2021-04-01',
  '2021-05-01',
  '2021-06-01',
  '2021-07-01',
  '2021-08-01',
  '2021-09-01',
  '2021-10-01',
  '2021-11-01',
  '2021-12-01',
  '2022-01-01',
  '2022-02-01',
  '2022-03-01',
  '2022-04-01',
  '2022-05-01',
  '2022-06-01',
  '2022-07-01',
  '2022-08-01',
  '2022-09-01',
  '2022-10-01',
  '2022-11-01',
  '2022-12-01',
  '2023-01-01',
  '2023-02-01',
  '2023-03-01',
  '2023-04-01',
  '2023-05-01',
  '2023-06-01',
  '2023-07-01',
  '2023-08-01',
  '2023-09-01',
  '2023-10-01',
  '2023-11-01',
  '2023-12-01',
  '2024-01-01',
  '2024-02-01',
  '2024-03-01',
  '2024-04-01',
  '2024-05-01',
  '2024-06-01',
  '2024-07-01',
  '2024-08-01',
  '2024-09-01',
  '2024-10-01',
  '2024-11-01',
  '2024-12-01',
  '2025-01-01',
  '2025-02-01',
  '2025-03-01',
  '2025-04-01',
  '2025-05-01',
  '2025-06-01',
  '2025-07-01',
  '2025-08-01',
  '2025-09-01',
  '2025-10-01',
  '2025-11-01',
  '2025-12-01',
  '2026-01-01',
  '2026-02-01',
  '2026-03-01',
  '2026-04-01',
  '2026-05-01',
  '2026-06-01'
];

export const oisstRmiDates = [
  '1981-09-01',
  '1981-10-01',
  '1981-11-01',
  '1981-12-01',
  '1982-01-01',
  '1982-02-01',
  '1982-03-01',
  '1982-04-01',
  '1982-05-01',
  '1982-06-01',
  '1982-07-01',
  '1982-08-01',
  '1982-09-01',
  '1982-10-01',
  '1982-11-01',
  '1982-12-01',
  '1983-01-01',
  '1983-02-01',
  '1983-03-01',
  '1983-04-01',
  '1983-05-01',
  '1983-06-01',
  '1983-07-01',
  '1983-08-01',
  '1983-09-01',
  '1983-10-01',
  '1983-11-01',
  '1983-12-01',
  '1984-01-01',
  '1984-02-01',
  '1984-03-01',
  '1984-04-01',
  '1984-05-01',
  '1984-06-01',
  '1984-07-01',
  '1984-08-01',
  '1984-09-01',
  '1984-10-01',
  '1984-11-01',
  '1984-12-01',
  '1985-01-01',
  '1985-02-01',
  '1985-03-01',
  '1985-04-01',
  '1985-05-01',
  '1985-06-01',
  '1985-07-01',
  '1985-08-01',
  '1985-09-01',
  '1985-10-01',
  '1985-11-01',
  '1985-12-01',
  '1986-01-01',
  '1986-02-01',
  '1986-03-01',
  '1986-04-01',
  '1986-05-01',
  '1986-06-01',
  '1986-07-01',
  '1986-08-01',
  '1986-09-01',
  '1986-10-01',
  '1986-11-01',
  '1986-12-01',
  '1987-01-01',
  '1987-02-01',
  '1987-03-01',
  '1987-04-01',
  '1987-05-01',
  '1987-06-01',
  '1987-07-01',
  '1987-08-01',
  '1987-09-01',
  '1987-10-01',
  '1987-11-01',
  '1987-12-01',
  '1988-01-01',
  '1988-02-01',
  '1988-03-01',
  '1988-04-01',
  '1988-05-01',
  '1988-06-01',
  '1988-07-01',
  '1988-08-01',
  '1988-09-01',
  '1988-10-01',
  '1988-11-01',
  '1988-12-01',
  '1989-01-01',
  '1989-02-01',
  '1989-03-01',
  '1989-04-01',
  '1989-05-01',
  '1989-06-01',
  '1989-07-01',
  '1989-08-01',
  '1989-09-01',
  '1989-10-01',
  '1989-11-01',
  '1989-12-01',
  '1990-01-01',
  '1990-02-01',
  '1990-03-01',
  '1990-04-01',
  '1990-05-01',
  '1990-06-01',
  '1990-07-01',
  '1990-08-01',
  '1990-09-01',
  '1990-10-01',
  '1990-11-01',
  '1990-12-01',
  '1991-01-01',
  '1991-02-01',
  '1991-03-01',
  '1991-04-01',
  '1991-05-01',
  '1991-06-01',
  '1991-07-01',
  '1991-08-01',
  '1991-09-01',
  '1991-10-01',
  '1991-11-01',
  '1991-12-01',
  '1992-01-01',
  '1992-02-01',
  '1992-03-01',
  '1992-04-01',
  '1992-05-01',
  '1992-06-01',
  '1992-07-01',
  '1992-08-01',
  '1992-09-01',
  '1992-10-01',
  '1992-11-01',
  '1992-12-01',
  '1993-01-01',
  '1993-02-01',
  '1993-03-01',
  '1993-04-01',
  '1993-05-01',
  '1993-06-01',
  '1993-07-01',
  '1993-08-01',
  '1993-09-01',
  '1993-10-01',
  '1993-11-01',
  '1993-12-01',
  '1994-01-01',
  '1994-02-01',
  '1994-03-01',
  '1994-04-01',
  '1994-05-01',
  '1994-06-01',
  '1994-07-01',
  '1994-08-01',
  '1994-09-01',
  '1994-10-01',
  '1994-11-01',
  '1994-12-01',
  '1995-01-01',
  '1995-02-01',
  '1995-03-01',
  '1995-04-01',
  '1995-05-01',
  '1995-06-01',
  '1995-07-01',
  '1995-08-01',
  '1995-09-01',
  '1995-10-01',
  '1995-11-01',
  '1995-12-01',
  '1996-01-01',
  '1996-02-01',
  '1996-03-01',
  '1996-04-01',
  '1996-05-01',
  '1996-06-01',
  '1996-07-01',
  '1996-08-01',
  '1996-09-01',
  '1996-10-01',
  '1996-11-01',
  '1996-12-01',
  '1997-01-01',
  '1997-02-01',
  '1997-03-01',
  '1997-04-01',
  '1997-05-01',
  '1997-06-01',
  '1997-07-01',
  '1997-08-01',
  '1997-09-01',
  '1997-10-01',
  '1997-11-01',
  '1997-12-01',
  '1998-01-01',
  '1998-02-01',
  '1998-03-01',
  '1998-04-01',
  '1998-05-01',
  '1998-06-01',
  '1998-07-01',
  '1998-08-01',
  '1998-09-01',
  '1998-10-01',
  '1998-11-01',
  '1998-12-01',
  '1999-01-01',
  '1999-02-01',
  '1999-03-01',
  '1999-04-01',
  '1999-05-01',
  '1999-06-01',
  '1999-07-01',
  '1999-08-01',
  '1999-09-01',
  '1999-10-01',
  '1999-11-01',
  '1999-12-01',
  '2000-01-01',
  '2000-02-01',
  '2000-03-01',
  '2000-04-01',
  '2000-05-01',
  '2000-06-01',
  '2000-07-01',
  '2000-08-01',
  '2000-09-01',
  '2000-10-01',
  '2000-11-01',
  '2000-12-01',
  '2001-01-01',
  '2001-02-01',
  '2001-03-01',
  '2001-04-01',
  '2001-05-01',
  '2001-06-01',
  '2001-07-01',
  '2001-08-01',
  '2001-09-01',
  '2001-10-01',
  '2001-11-01',
  '2001-12-01',
  '2002-01-01',
  '2002-02-01',
  '2002-03-01',
  '2002-04-01',
  '2002-05-01',
  '2002-06-01',
  '2002-07-01',
  '2002-08-01',
  '2002-09-01',
  '2002-10-01',
  '2002-11-01',
  '2002-12-01',
  '2003-01-01',
  '2003-02-01',
  '2003-03-01',
  '2003-04-01',
  '2003-05-01',
  '2003-06-01',
  '2003-07-01',
  '2003-08-01',
  '2003-09-01',
  '2003-10-01',
  '2003-11-01',
  '2003-12-01',
  '2004-01-01',
  '2004-02-01',
  '2004-03-01',
  '2004-04-01',
  '2004-05-01',
  '2004-06-01',
  '2004-07-01',
  '2004-08-01',
  '2004-09-01',
  '2004-10-01',
  '2004-11-01',
  '2004-12-01',
  '2005-01-01',
  '2005-02-01',
  '2005-03-01',
  '2005-04-01',
  '2005-05-01',
  '2005-06-01',
  '2005-07-01',
  '2005-08-01',
  '2005-09-01',
  '2005-10-01',
  '2005-11-01',
  '2005-12-01',
  '2006-01-01',
  '2006-02-01',
  '2006-03-01',
  '2006-04-01',
  '2006-05-01',
  '2006-06-01',
  '2006-07-01',
  '2006-08-01',
  '2006-09-01',
  '2006-10-01',
  '2006-11-01',
  '2006-12-01',
  '2007-01-01',
  '2007-02-01',
  '2007-03-01',
  '2007-04-01',
  '2007-05-01',
  '2007-06-01',
  '2007-07-01',
  '2007-08-01',
  '2007-09-01',
  '2007-10-01',
  '2007-11-01',
  '2007-12-01',
  '2008-01-01',
  '2008-02-01',
  '2008-03-01',
  '2008-04-01',
  '2008-05-01',
  '2008-06-01',
  '2008-07-01',
  '2008-08-01',
  '2008-09-01',
  '2008-10-01',
  '2008-11-01',
  '2008-12-01',
  '2009-01-01',
  '2009-02-01',
  '2009-03-01',
  '2009-04-01',
  '2009-05-01',
  '2009-06-01',
  '2009-07-01',
  '2009-08-01',
  '2009-09-01',
  '2009-10-01',
  '2009-11-01',
  '2009-12-01',
  '2010-01-01',
  '2010-02-01',
  '2010-03-01',
  '2010-04-01',
  '2010-05-01',
  '2010-06-01',
  '2010-07-01',
  '2010-08-01',
  '2010-09-01',
  '2010-10-01',
  '2010-11-01',
  '2010-12-01',
  '2011-01-01',
  '2011-02-01',
  '2011-03-01',
  '2011-04-01',
  '2011-05-01',
  '2011-06-01',
  '2011-07-01',
  '2011-08-01',
  '2011-09-01',
  '2011-10-01',
  '2011-11-01',
  '2011-12-01',
  '2012-01-01',
  '2012-02-01',
  '2012-03-01',
  '2012-04-01',
  '2012-05-01',
  '2012-06-01',
  '2012-07-01',
  '2012-08-01',
  '2012-09-01',
  '2012-10-01',
  '2012-11-01',
  '2012-12-01',
  '2013-01-01',
  '2013-02-01',
  '2013-03-01',
  '2013-04-01',
  '2013-05-01',
  '2013-06-01',
  '2013-07-01',
  '2013-08-01',
  '2013-09-01',
  '2013-10-01',
  '2013-11-01',
  '2013-12-01',
  '2014-01-01',
  '2014-02-01',
  '2014-03-01',
  '2014-04-01',
  '2014-05-01',
  '2014-06-01',
  '2014-07-01',
  '2014-08-01',
  '2014-09-01',
  '2014-10-01',
  '2014-11-01',
  '2014-12-01',
  '2015-01-01',
  '2015-02-01',
  '2015-03-01',
  '2015-04-01',
  '2015-05-01',
  '2015-06-01',
  '2015-07-01',
  '2015-08-01',
  '2015-09-01',
  '2015-10-01',
  '2015-11-01',
  '2015-12-01',
  '2016-01-01',
  '2016-02-01',
  '2016-03-01',
  '2016-04-01',
  '2016-05-01',
  '2016-06-01',
  '2016-07-01',
  '2016-08-01',
  '2016-09-01',
  '2016-10-01',
  '2016-11-01',
  '2016-12-01',
  '2017-01-01',
  '2017-02-01',
  '2017-03-01',
  '2017-04-01',
  '2017-05-01',
  '2017-06-01',
  '2017-07-01',
  '2017-08-01',
  '2017-09-01',
  '2017-10-01',
  '2017-11-01',
  '2017-12-01',
  '2018-01-01',
  '2018-02-01',
  '2018-03-01',
  '2018-04-01',
  '2018-05-01',
  '2018-06-01',
  '2018-07-01',
  '2018-08-01',
  '2018-09-01',
  '2018-10-01',
  '2018-11-01',
  '2018-12-01',
  '2019-01-01',
  '2019-02-01',
  '2019-03-01',
  '2019-04-01',
  '2019-05-01',
  '2019-06-01',
  '2019-07-01',
  '2019-08-01',
  '2019-09-01',
  '2019-10-01',
  '2019-11-01',
  '2019-12-01',
  '2020-01-01',
  '2020-02-01',
  '2020-03-01',
  '2020-04-01',
  '2020-05-01',
  '2020-06-01',
  '2020-07-01',
  '2020-08-01',
  '2020-09-01',
  '2020-10-01',
  '2020-11-01',
  '2020-12-01',
  '2021-01-01',
  '2021-02-01',
  '2021-03-01',
  '2021-04-01',
  '2021-05-01',
  '2021-06-01',
  '2021-07-01',
  '2021-08-01',
  '2021-09-01',
  '2021-10-01',
  '2021-11-01',
  '2021-12-01',
  '2022-01-01',
  '2022-02-01',
  '2022-03-01',
  '2022-04-01',
  '2022-05-01',
  '2022-06-01',
  '2022-07-01',
  '2022-08-01',
  '2022-09-01',
  '2022-10-01',
  '2022-11-01',
  '2022-12-01',
  '2023-01-01',
  '2023-02-01',
  '2023-03-01',
  '2023-04-01',
  '2023-05-01',
  '2023-06-01',
  '2023-07-01',
  '2023-08-01',
  '2023-09-01',
  '2023-10-01',
  '2023-11-01',
  '2023-12-01',
  '2024-01-01',
  '2024-02-01',
  '2024-03-01',
  '2024-04-01',
  '2024-05-01',
  '2024-06-01',
  '2024-07-01',
  '2024-08-01',
  '2024-09-01',
  '2024-10-01',
  '2024-11-01',
  '2024-12-01',
  '2025-01-01',
  '2025-02-01',
  '2025-03-01',
  '2025-04-01',
  '2025-05-01',
  '2025-06-01',
  '2025-07-01',
  '2025-08-01',
  '2025-09-01',
  '2025-10-01',
  '2025-11-01',
  '2025-12-01',
  '2026-01-01',
  '2026-02-01',
  '2026-03-01',
  '2026-04-01',
  '2026-05-01',
  '2026-06-01'
];

export const oisstIndoPacificDates = [
  '1981-09-01',
  '1981-10-01',
  '1981-11-01',
  '1981-12-01',
  '1982-01-01',
  '1982-02-01',
  '1982-03-01',
  '1982-04-01',
  '1982-05-01',
  '1982-06-01',
  '1982-07-01',
  '1982-08-01',
  '1982-09-01',
  '1982-10-01',
  '1982-11-01',
  '1982-12-01',
  '1983-01-01',
  '1983-02-01',
  '1983-03-01',
  '1983-04-01',
  '1983-05-01',
  '1983-06-01',
  '1983-07-01',
  '1983-08-01',
  '1983-09-01',
  '1983-10-01',
  '1983-11-01',
  '1983-12-01',
  '1984-01-01',
  '1984-02-01',
  '1984-03-01',
  '1984-04-01',
  '1984-05-01',
  '1984-06-01',
  '1984-07-01',
  '1984-08-01',
  '1984-09-01',
  '1984-10-01',
  '1984-11-01',
  '1984-12-01',
  '1985-01-01',
  '1985-02-01',
  '1985-03-01',
  '1985-04-01',
  '1985-05-01',
  '1985-06-01',
  '1985-07-01',
  '1985-08-01',
  '1985-09-01',
  '1985-10-01',
  '1985-11-01',
  '1985-12-01',
  '1986-01-01',
  '1986-02-01',
  '1986-03-01',
  '1986-04-01',
  '1986-05-01',
  '1986-06-01',
  '1986-07-01',
  '1986-08-01',
  '1986-09-01',
  '1986-10-01',
  '1986-11-01',
  '1986-12-01',
  '1987-01-01',
  '1987-02-01',
  '1987-03-01',
  '1987-04-01',
  '1987-05-01',
  '1987-06-01',
  '1987-07-01',
  '1987-08-01',
  '1987-09-01',
  '1987-10-01',
  '1987-11-01',
  '1987-12-01',
  '1988-01-01',
  '1988-02-01',
  '1988-03-01',
  '1988-04-01',
  '1988-05-01',
  '1988-06-01',
  '1988-07-01',
  '1988-08-01',
  '1988-09-01',
  '1988-10-01',
  '1988-11-01',
  '1988-12-01',
  '1989-01-01',
  '1989-02-01',
  '1989-03-01',
  '1989-04-01',
  '1989-05-01',
  '1989-06-01',
  '1989-07-01',
  '1989-08-01',
  '1989-09-01',
  '1989-10-01',
  '1989-11-01',
  '1989-12-01',
  '1990-01-01',
  '1990-02-01',
  '1990-03-01',
  '1990-04-01',
  '1990-05-01',
  '1990-06-01',
  '1990-07-01',
  '1990-08-01',
  '1990-09-01',
  '1990-10-01',
  '1990-11-01',
  '1990-12-01',
  '1991-01-01',
  '1991-02-01',
  '1991-03-01',
  '1991-04-01',
  '1991-05-01',
  '1991-06-01',
  '1991-07-01',
  '1991-08-01',
  '1991-09-01',
  '1991-10-01',
  '1991-11-01',
  '1991-12-01',
  '1992-01-01',
  '1992-02-01',
  '1992-03-01',
  '1992-04-01',
  '1992-05-01',
  '1992-06-01',
  '1992-07-01',
  '1992-08-01',
  '1992-09-01',
  '1992-10-01',
  '1992-11-01',
  '1992-12-01',
  '1993-01-01',
  '1993-02-01',
  '1993-03-01',
  '1993-04-01',
  '1993-05-01',
  '1993-06-01',
  '1993-07-01',
  '1993-08-01',
  '1993-09-01',
  '1993-10-01',
  '1993-11-01',
  '1993-12-01',
  '1994-01-01',
  '1994-02-01',
  '1994-03-01',
  '1994-04-01',
  '1994-05-01',
  '1994-06-01',
  '1994-07-01',
  '1994-08-01',
  '1994-09-01',
  '1994-10-01',
  '1994-11-01',
  '1994-12-01',
  '1995-01-01',
  '1995-02-01',
  '1995-03-01',
  '1995-04-01',
  '1995-05-01',
  '1995-06-01',
  '1995-07-01',
  '1995-08-01',
  '1995-09-01',
  '1995-10-01',
  '1995-11-01',
  '1995-12-01',
  '1996-01-01',
  '1996-02-01',
  '1996-03-01',
  '1996-04-01',
  '1996-05-01',
  '1996-06-01',
  '1996-07-01',
  '1996-08-01',
  '1996-09-01',
  '1996-10-01',
  '1996-11-01',
  '1996-12-01',
  '1997-01-01',
  '1997-02-01',
  '1997-03-01',
  '1997-04-01',
  '1997-05-01',
  '1997-06-01',
  '1997-07-01',
  '1997-08-01',
  '1997-09-01',
  '1997-10-01',
  '1997-11-01',
  '1997-12-01',
  '1998-01-01',
  '1998-02-01',
  '1998-03-01',
  '1998-04-01',
  '1998-05-01',
  '1998-06-01',
  '1998-07-01',
  '1998-08-01',
  '1998-09-01',
  '1998-10-01',
  '1998-11-01',
  '1998-12-01',
  '1999-01-01',
  '1999-02-01',
  '1999-03-01',
  '1999-04-01',
  '1999-05-01',
  '1999-06-01',
  '1999-07-01',
  '1999-08-01',
  '1999-09-01',
  '1999-10-01',
  '1999-11-01',
  '1999-12-01',
  '2000-01-01',
  '2000-02-01',
  '2000-03-01',
  '2000-04-01',
  '2000-05-01',
  '2000-06-01',
  '2000-07-01',
  '2000-08-01',
  '2000-09-01',
  '2000-10-01',
  '2000-11-01',
  '2000-12-01',
  '2001-01-01',
  '2001-02-01',
  '2001-03-01',
  '2001-04-01',
  '2001-05-01',
  '2001-06-01',
  '2001-07-01',
  '2001-08-01',
  '2001-09-01',
  '2001-10-01',
  '2001-11-01',
  '2001-12-01',
  '2002-01-01',
  '2002-02-01',
  '2002-03-01',
  '2002-04-01',
  '2002-05-01',
  '2002-06-01',
  '2002-07-01',
  '2002-08-01',
  '2002-09-01',
  '2002-10-01',
  '2002-11-01',
  '2002-12-01',
  '2003-01-01',
  '2003-02-01',
  '2003-03-01',
  '2003-04-01',
  '2003-05-01',
  '2003-06-01',
  '2003-07-01',
  '2003-08-01',
  '2003-09-01',
  '2003-10-01',
  '2003-11-01',
  '2003-12-01',
  '2004-01-01',
  '2004-02-01',
  '2004-03-01',
  '2004-04-01',
  '2004-05-01',
  '2004-06-01',
  '2004-07-01',
  '2004-08-01',
  '2004-09-01',
  '2004-10-01',
  '2004-11-01',
  '2004-12-01',
  '2005-01-01',
  '2005-02-01',
  '2005-03-01',
  '2005-04-01',
  '2005-05-01',
  '2005-06-01',
  '2005-07-01',
  '2005-08-01',
  '2005-09-01',
  '2005-10-01',
  '2005-11-01',
  '2005-12-01',
  '2006-01-01',
  '2006-02-01',
  '2006-03-01',
  '2006-04-01',
  '2006-05-01',
  '2006-06-01',
  '2006-07-01',
  '2006-08-01',
  '2006-09-01',
  '2006-10-01',
  '2006-11-01',
  '2006-12-01',
  '2007-01-01',
  '2007-02-01',
  '2007-03-01',
  '2007-04-01',
  '2007-05-01',
  '2007-06-01',
  '2007-07-01',
  '2007-08-01',
  '2007-09-01',
  '2007-10-01',
  '2007-11-01',
  '2007-12-01',
  '2008-01-01',
  '2008-02-01',
  '2008-03-01',
  '2008-04-01',
  '2008-05-01',
  '2008-06-01',
  '2008-07-01',
  '2008-08-01',
  '2008-09-01',
  '2008-10-01',
  '2008-11-01',
  '2008-12-01',
  '2009-01-01',
  '2009-02-01',
  '2009-03-01',
  '2009-04-01',
  '2009-05-01',
  '2009-06-01',
  '2009-07-01',
  '2009-08-01',
  '2009-09-01',
  '2009-10-01',
  '2009-11-01',
  '2009-12-01',
  '2010-01-01',
  '2010-02-01',
  '2010-03-01',
  '2010-04-01',
  '2010-05-01',
  '2010-06-01',
  '2010-07-01',
  '2010-08-01',
  '2010-09-01',
  '2010-10-01',
  '2010-11-01',
  '2010-12-01',
  '2011-01-01',
  '2011-02-01',
  '2011-03-01',
  '2011-04-01',
  '2011-05-01',
  '2011-06-01',
  '2011-07-01',
  '2011-08-01',
  '2011-09-01',
  '2011-10-01',
  '2011-11-01',
  '2011-12-01',
  '2012-01-01',
  '2012-02-01',
  '2012-03-01',
  '2012-04-01',
  '2012-05-01',
  '2012-06-01',
  '2012-07-01',
  '2012-08-01',
  '2012-09-01',
  '2012-10-01',
  '2012-11-01',
  '2012-12-01',
  '2013-01-01',
  '2013-02-01',
  '2013-03-01',
  '2013-04-01',
  '2013-05-01',
  '2013-06-01',
  '2013-07-01',
  '2013-08-01',
  '2013-09-01',
  '2013-10-01',
  '2013-11-01',
  '2013-12-01',
  '2014-01-01',
  '2014-02-01',
  '2014-03-01',
  '2014-04-01',
  '2014-05-01',
  '2014-06-01',
  '2014-07-01',
  '2014-08-01',
  '2014-09-01',
  '2014-10-01',
  '2014-11-01',
  '2014-12-01',
  '2015-01-01',
  '2015-02-01',
  '2015-03-01',
  '2015-04-01',
  '2015-05-01',
  '2015-06-01',
  '2015-07-01',
  '2015-08-01',
  '2015-09-01',
  '2015-10-01',
  '2015-11-01',
  '2015-12-01',
  '2016-01-01',
  '2016-02-01',
  '2016-03-01',
  '2016-04-01',
  '2016-05-01',
  '2016-06-01',
  '2016-07-01',
  '2016-08-01',
  '2016-09-01',
  '2016-10-01',
  '2016-11-01',
  '2016-12-01',
  '2017-01-01',
  '2017-02-01',
  '2017-03-01',
  '2017-04-01',
  '2017-05-01',
  '2017-06-01',
  '2017-07-01',
  '2017-08-01',
  '2017-09-01',
  '2017-10-01',
  '2017-11-01',
  '2017-12-01',
  '2018-01-01',
  '2018-02-01',
  '2018-03-01',
  '2018-04-01',
  '2018-05-01',
  '2018-06-01',
  '2018-07-01',
  '2018-08-01',
  '2018-09-01',
  '2018-10-01',
  '2018-11-01',
  '2018-12-01',
  '2019-01-01',
  '2019-02-01',
  '2019-03-01',
  '2019-04-01',
  '2019-05-01',
  '2019-06-01',
  '2019-07-01',
  '2019-08-01',
  '2019-09-01',
  '2019-10-01',
  '2019-11-01',
  '2019-12-01',
  '2020-01-01',
  '2020-02-01',
  '2020-03-01',
  '2020-04-01',
  '2020-05-01',
  '2020-06-01',
  '2020-07-01',
  '2020-08-01',
  '2020-09-01',
  '2020-10-01',
  '2020-11-01',
  '2020-12-01',
  '2021-01-01',
  '2021-02-01',
  '2021-03-01',
  '2021-04-01',
  '2021-05-01',
  '2021-06-01',
  '2021-07-01',
  '2021-08-01',
  '2021-09-01',
  '2021-10-01',
  '2021-11-01',
  '2021-12-01',
  '2022-01-01',
  '2022-02-01',
  '2022-03-01',
  '2022-04-01',
  '2022-05-01',
  '2022-06-01',
  '2022-07-01',
  '2022-08-01',
  '2022-09-01',
  '2022-10-01',
  '2022-11-01',
  '2022-12-01',
  '2023-01-01',
  '2023-02-01',
  '2023-03-01',
  '2023-04-01',
  '2023-05-01',
  '2023-06-01',
  '2023-07-01',
  '2023-08-01',
  '2023-09-01',
  '2023-10-01',
  '2023-11-01',
  '2023-12-01',
  '2024-01-01',
  '2024-02-01',
  '2024-03-01',
  '2024-04-01',
  '2024-05-01',
  '2024-06-01',
  '2024-07-01',
  '2024-08-01',
  '2024-09-01',
  '2024-10-01',
  '2024-11-01',
  '2024-12-01',
  '2025-01-01',
  '2025-02-01',
  '2025-03-01',
  '2025-04-01',
  '2025-05-01',
  '2025-06-01',
  '2025-07-01',
  '2025-08-01',
  '2025-09-01',
  '2025-10-01',
  '2025-11-01',
  '2025-12-01',
  '2026-01-01',
  '2026-02-01',
  '2026-03-01',
  '2026-04-01',
  '2026-05-01',
  '2026-06-01'
];

export const oisstRegionMetadata = {
  palau: {
    label: 'Palau EEZ',
    averageCsvUrl: '/jsonFiles/oisst/palau/average_oisst_monthly_enso.csv',
    locationJsonUrl: '/jsonFiles/oisst/palau/oisst_monthly_by_location_latest.json',
    overlayUrl: '/CMIPtas/palauEEZ.json',
  },
  rmi: {
    label: 'Marshall Islands EEZ',
    averageCsvUrl: '/jsonFiles/oisst/rmi/average_oisst_monthly_enso.csv',
    locationJsonUrl: '/jsonFiles/oisst/rmi/oisst_monthly_by_location_latest.json',
    overlayUrl: '/CMIPtas/rmiEEZ.json',
  },
};
